import Api from "../../../../lib/api";

export default class CheckoutService {

    static getComingGroupsInfo(courseId) {
        return Api.get(`${Api.lmsApiUrl}/groups/course/${courseId}/site-starts-soon`, {}, { withCredentials: true });
    }

    static getPaymentInfo(groupId, params = {}, options = {}) {
        return Api.get(`${Api.lmsApiUrl}/groups/${groupId}/site-buy`, params, Object.assign(options, {
            altArray: true,
            sendEmptyArray: true,
            withCredentials: true
        }));
    }

    static getSiteOrderResult(orderId) {
        return Api.get(`${Api.lmsApiUrl}/online-payment/site/order/${orderId}/result`, {}, {
            withCredentials: true
        });
    }

    static cancelSiteOrder(orderId) {
        return Api.post(`${Api.lmsApiUrl}/online-payment/site/order/${orderId}/cancel`, {}, {
            withCredentials: true
        });
    }
}